import { getElementStyleMathValue } from '@gp/utils/common';

// project详情页固定header的高度
export const FIXED_HEADER_HEIGHT = 76;

/**
 * 获取project详情页头部的总高度
 * @returns project详情页头部的总高度
 */
export const getProjectDetailsHeaderHeight = (
  detailsPageNode: Element | null = document.querySelector('.dbg-project-details'),
): number => {
  if (!detailsPageNode) return 0;
  // project详情页header节点
  const headerNode = detailsPageNode?.querySelector('.dbg-project-details-header');
  // 游戏详情页头部总高度
  return getElementStyleMathValue(headerNode as any, 'height');
};
